import React, { FC } from 'react'
import FavoriteConnector, {
  ConnectorProps as FavoriteConnectorProps,
} from 'containers/SessionFavorites'
import FlashMessagesConnector, {
  ConnectorProps as FlashMessagesConnectorProps,
} from 'containers/FlashMessage'
import FavoriteIcon from 'svg/heart-icon.svg'
import FavoriteFilledIcon from 'svg/heart-icon-filled.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'
import useFavorite from './useFavorite'

type FavoriteProps = FavoriteConnectorProps &
  FlashMessagesConnectorProps & {
    artworkId: number
  }

const Favorite: FC<FavoriteProps> = (props) => {
  const { formAction, onClickFavorite, isFavorite, shouldBlockEvents } = useFavorite(props)

  return (
    <button
      className={classNames(styles.iconButtonDefaultStyle, styles.iconActionContainer)}
      data-action={formAction}
      data-type='action'
      rel='nofollow'
      title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
      onClick={onClickFavorite}
      disabled={shouldBlockEvents}
    >
      <FavoriteFilledIcon
        className={classNames(styles.iconActionFavorite, {
          [styles.iconActionContainerInvisible]: !isFavorite,
        })}
      />
      {!isFavorite && <FavoriteIcon className={styles.iconActionFavorite} />}
    </button>
  )
}

export default FavoriteConnector(FlashMessagesConnector(Favorite))
